module.exports = "../img/LN.svg";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/LN.svg
// module id = 33
// module chunks = 0